module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-divider', [_vm._v("秩序册信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "赛季",
      "value": _vm.pageData.sjname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "赛区",
      "value": _vm.pageData.sqname
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "单位",
      "value": _vm.pageData.danwei
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "队伍名称",
      "value": _vm.pageData.mingcheng
    }
  }), _vm._v(" "), (_vm.pageData.heying) ? _c('van-cell', {
    attrs: {
      "title": "队伍合影"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.pageData.heying
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "src": _vm.pageData.heying
    }
  })])]) : _c('van-cell', {
    attrs: {
      "title": "队伍合影",
      "is-link": ""
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "",
      "accept": "image/*",
      "show-file-list": false,
      "before-upload": _vm.onReadHeying
    }
  }, [_vm._v("\n                点击上传\n            ")])], 1)], 1), _vm._v(" "), _c('van-divider', [_vm._v("人员信息")]), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.lingdui_list), function(user) {
    return _c('van-cell', {
      attrs: {
        "title": "领队",
        "value": user.name,
        "label": '身份证:' + user.num
      }
    })
  }), 1), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.jiaolianyuan_list), function(user, index) {
    return _c('van-cell', {
      attrs: {
        "title": '教练员' + (index + 1),
        "value": user.name,
        "label": '身份证:' + user.num
      }
    })
  }), 1), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.caipanyuan_list), function(user, index) {
    return _c('van-cell', {
      attrs: {
        "title": '裁判员' + (index + 1),
        "value": user.name,
        "label": '身份证:' + user.num
      }
    })
  }), 1), _vm._v(" "), _c('van-cell-group', _vm._l((_vm.pageData.yundongyuan_list), function(user, index) {
    return _c('van-cell', {
      attrs: {
        "title": '运动员' + (index + 1),
        "value": user.name,
        "label": '身份证:' + user.num
      }
    })
  }), 1), _vm._v(" "), _c('van-divider', [_vm._v("参赛人数")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": "领队",
      "value": "1"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "教练员",
      "value": _vm.pageData.jiaolianyuan_list.length
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "裁判员",
      "value": _vm.pageData.caipanyuan_list.length
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "运动员",
      "value": _vm.pageData.yundongyuan_list.length
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "总计",
      "value": _vm.pageData.member_total_count
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [(_vm.pageData.confirm_1 == 2) ? _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.save($event)
      }
    }
  }, [_vm._v("信息无误 我已确认")]) : _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "plain": ""
    }
  }, [_vm._v("信息已确认")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.edit($event)
      }
    }
  }, [_vm._v("信息需要修改")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "size": "large",
      "plain": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.goIndex($event)
      }
    }
  }, [_vm._v("返回首页")])], 1), _vm._v(" "), (_vm.loadding) ? _c('div', {
    staticClass: "mask"
  }, [_c('van-loading', {
    attrs: {
      "type": "spinner",
      "color": "white"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145f5749","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/sai/saiConfirmDetail1.vue
// module id = 1149
// module chunks = 0